"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function Docker(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { d: "M17.81 8.725l.258.207c.673.517 1.19 1.19 1.293 2.017.777-.207 1.708-.155 2.38.259l.26.155-.156.259c-.569 1.138-1.759 1.448-2.949 1.397-1.81 4.345-5.639 6.363-10.295 6.363-2.43 0-4.656-.931-5.897-3.001v-.051l-.207-.363a5.812 5.812 0 0 1-.466-2.948l.052-.311h13.4c.464 0 .93-.052 1.396-.207.207-.104.465-.207.672-.31-.259-.362-.414-.828-.465-1.294-.052-.62.103-1.448.517-1.914l.207-.258zM6.014 14.519c-.62 0-1.086.465-1.086 1.034 0 .57.517 1.035 1.086 1.035.57 0 1.087-.465 1.087-1.035 0-.569-.466-1.034-1.087-1.034zm-.362-4.915H7.67V7.586H5.652v2.018zm2.535 0h2.018V7.586H8.187v2.018zM3.17 12.14h2.018v-2.018H3.17v2.018zm5.018 0h2.018v-2.018H8.187v2.018zm-2.535 0H7.67v-2.018H5.652v2.018zm7.501 0h2.018v-2.018h-2.018v2.018zM10.67 7.018h2.018V5H10.67v2.018zm0 2.586h2.018V7.586H10.67v2.018zm0 2.536h2.018v-2.018H10.67v2.018z", fill: props.color || "#000", fillRule: "nonzero" })));
}
exports.default = Docker;
